<template>
  <div class="home">
    <div class="slider">
      <template>
        <a-carousel autoplay dotsClass="slick-dots slick-thumb clearfix">
          <a slot="customPaging" slot-scope="props">
            <img :src="getImgUrl(props.i)" />
          </a>
          <div v-for="(ban, index) in banners" :key="'ban' + index">
            <img :src="ban.url" />
          </div>
        </a-carousel>
      </template>
    </div>
    <div class="model" style="margin-top: -70px;">
      <div class="m-t">
        <div>新闻中心 <span>/ NEWS CENTER</span></div>
        <i type="1" @click="toModel">MORE<a-icon type="plus" /></i>
      </div>
      <div class="m-c clearfix">
        <div @click="toNewDetail" :nId="newd.id" class="new" v-for="(newd,index) in news" :key="'newd' + index">
          <div class="pic"><img :src="newd.bgUrl"></div>
          <div class="text">{{newd.name}}</div>
          <div class="time">发布时间：{{newd.time}}</div>
          <div class="ho-title">{{newd.name}}</div>
        </div>
      </div>
    </div>
    <div class="model">
      <div class="m-t">
        <div>基金会简介 <span>/ FOUNDATION PROFILE</span></div>
        <i type="2" @click="toModel">MORE<a-icon type="plus" /></i>
      </div>
      <div class="m-c">
        <div class="profile">
          <dl class="clearfix">
            <dd>&nbsp;</dd>
            <dd><img class="m-1" src="../../assets/info_2.jpg"/></dd>
            <dd>&nbsp;</dd>
            <dd>&nbsp;</dd>
          </dl>
          <dl class="clearfix">
            <dd><img class="m-2" src="../../assets/info_1.png"/></dd>
            <dd>
              <div class="text">
                <div class="t-t">金螳螂公益慈善基金会简介</div>
                <div class="t-c">2015年3月，通过全员募捐、公司捐款和金螳螂控股朱兴良董事长个人捐赠形式募集善款，金螳螂公益慈善基金会在苏州市民政局注册成立，原始注册资金5000万元，成为苏州较大规模的非公募公益基金会。2017年6月，金螳螂公益慈善基金会成为苏州首家被认定的“慈善组织”，2017年11月，被评为4A级社会组织，2018年9月，荣获第三届苏州慈善奖“最具影响力慈善组织”，同年，金螳螂集团荣获第四届江苏慈善奖“最具爱心捐赠单位”，2019年荣获江苏省“慈善之星”。</div>
              </div>
            </dd>
            <dd>
              <div class="detail"><span type="3" @click="toModel">查看详情<a-icon type="caret-right" /></span></div>
            </dd>
            <dd><img class="m-3" src="../../assets/info_3.png"/></dd>
          </dl>
          <dl class="clearfix">
            <dd>&nbsp;</dd>
            <dd>&nbsp;</dd>
            <dd><img class="m-4" src="../../assets/info_4.png"/></dd>
            <dd>&nbsp;</dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      news: [
        {
          id: '1',
          time: '2019年06月07日',
          bgUrl: 'http://fundation.goldmantis.com:8444/files/news/new11.png',
          name: '“浓情端午，‘粽’享爱心”助老公益活动圆满举行'
        },
        {
          id: '5',
          time: '2019年05月10日',
          bgUrl: 'http://fundation.goldmantis.com:8444/files/news/new51.png',
          name: '爱心捐助 贵州娃娃在苏成功“补心”'
        },
        {
          id: '4',
          time: '2019年05月05日',
          bgUrl: 'http://fundation.goldmantis.com:8444/files/news/new41.png',
          name: '金螳螂公益慈善基金会荣获“中国慈善榜慈善榜样”'
        }
      ],
      banners: [
        {url: 'http://fundation.goldmantis.com:8444/files/banner/3.jpg'},
        {url: 'http://fundation.goldmantis.com:8444/files/banner/2.jpg'},
        {url: 'http://fundation.goldmantis.com:8444/files/banner/1.jpg'}
        
      ]
    }
  },
  mounted: function(){
    this.init();
  },
  methods: {
    init () {

    },
    getImgUrl(i) {
      return this.banners[i].url;
    },
    toModel (event) {
      var type = event.currentTarget.getAttribute('type');
      if(type == '1'){
        this.$router.push("new")
      }else if(type == '2'){
        this.$router.push("about/profile")
      }else if(type == '3'){
        this.$router.push("about/profile")
      }
    },
    toNewDetail () {
      var newId = event.currentTarget.getAttribute('nId');
      this.$router.push("newd/" + newId)
    }
  },
}
</script>

<style lang="scss" scoped>
  @import '../../scss/views/home';
</style>

<style scoped>
/* For demo */
.ant-carousel{
  font-size: 0px;
}
.ant-carousel >>> .slick-dots {
  height: auto
}
.ant-carousel >>> .slick-slide img{
    display: block;
    margin: auto;
    max-width: 100%;
}
.ant-carousel >>> .slick-thumb {
  position: relative;
  padding: 20px;
  top: -80px;
  width: 1200px;
  margin: 0 auto;
  bottom: 0px;
  height: 200px;
  background: rgba(255,255,255,0.95);
  overflow: hidden;
}
.ant-carousel >>> .slick-thumb li {
  margin-left: 1.6%;
  width: 32%;
  height: 160px;
  overflow: hidden;
  font-size: 0;
  border: 1px solid #efefef;
}
.ant-carousel >>> .slick-thumb li:nth-child(1){
  margin-left: 0;
}
.ant-carousel >>> .slick-thumb li img {
  width: 100%;
  filter: blur(2px);
}
.ant-carousel >>> .slick-thumb li.slick-active img{
    filter: blur(0);
}
</style>